<template>
	<div>
		<iframe width="100%" height="2000" :srcdoc="html_form" id="iframe" sandbox="allow-forms allow-scripts allow-same-origin allow-popups allow-popups-to-escape-sandbox allow-modals"></iframe>
	</div>
</template>

<script>
	import { uuid } from "vue-uuid";

	import store from "../store";
	import form from "../services/form";
	import users from "../services/users.js";
	import userActions from "../services/userActions.js";
	import messages_services from "../services/messages.js";

	export default {
		name: "form",
		data() {
			return {
				url: "",
				html_form: ""
			};
		},
		props: {
			uid: {
				default: "",
            },
        },
		computed: {
			event() {
				return this.$store.getters.getEvent
			}
		},
		watch: {
			event: async function (event) {
				if (event.type == "formulaire_done")
				{
					if (this.params)
					{
						var actions = await userActions.get("SELECT", this.params.table, {
							where: "`" + this.params.column_active + '`' + " = 1 and `" + this.params.column_element + "` = '" + this.uid + "' ORDER BY `" + this.params.column_date + "` DESC limit 1"
						}, false);

						console.log(actions)

						if (actions.length > 0)
						{
							var action = actions[0];

							var response = await userActions.get(
								"update",
								this.params.table,
								{
									set: '`' + this.params.column_active + '` = 0',
									where: 'id = ' + action.id,
								},
								false
							);

							if (this.params.column_notification && action[this.params.column_notification])
							{
								await messages_services.post("", null, action[this.params.column_notification], "notification");
							}

						}
					}

                    this.$emit("done");
				}
			}
		},
		methods: {
			async get_form(uid)
			{
				this.html_form = " ";
				this.html_form = await form.getForm(this.uid);
			},
		},
		created: async function () {
            
			this.get_form();
			
			let response = await users.getSelf(true);
			this.params = response.client.details.actions;
        },
	};
</script>

<style></style>
